<template lang='pug'>
  .mr-newsletter-subscription
    p.success-alert(v-if="justSubscribed" role="alert") You have been successfully subscribed!
    p(v-if="isSubscribed") Your on the list!
    form(v-if="!isSubscribed && !justSubscribed" name="newsletterForm" ref="newsletterForm" v-on:submit.prevent="newsLetterSignUp()")
      input#newsletter-signup(name="emailInput" type='email' placeholder='Enter your email' v-model="email" @input="$v.email.$touch()" required)
      button.button(v-if='!isSubscribed' type="submit" aria-label="join") {{buttonText || 'JOIN'}}
</template>

<script>
  import sentry from '../addSentry.js';
  import { getSignInData } from "../services/vueCustomerSvc";

  const { required, email } = require("vuelidate/lib/validators");
  export default {
    props: ['buttonText', 'source'],
    data: function() {
      return {
        email: '',
        isSubscribed: false,
        justSubscribed: false,
        newsletterMessage: ''
      }
    },
    validations: {
      email: {
        required,
        email
      }
    },
    methods: {
      newsLetterSignUp: function() {
        if (this.$v.$invalid) {
          return;
        }
        this.$http.post('/api/customer/newsletterSignUp', {
          email: this.email,
          source: this.source
        })
        .then(results => {
          this.justSubscribed = true;
        });
      }
    },
    created() {
      getSignInData().then(results => {
        if (results.data.email) {
          this.isSubscribed = true;
        }
      }).catch(err => {
        // send to sentry
        sentry.withScope(scope => {
          scope.setTag('vueComponent', 'mrNewsletterSubscription');
          sentry.captureException(err);
        });
      });;
    }
  };
</script>
